// Application Global Configuration
// export const API_BASE_URL =
//   "https://stagings.vaps.parkwayprojects.xyz/SAP-API/api";
export const API_BASE_URL = "https://portal.swwipe.com/SAP.API/api";

export const APP_ITEMS_ENDPOINT = `${API_BASE_URL}/app/get-appitems`;
export const GETAPPITEMS_BYID_ENDPOINT = `${API_BASE_URL}/app/get-appitem`;
export const GETCATEGORIES_ENDPOINT = `${API_BASE_URL}/app/get-categories`;
export const USER_PRIVILEGES_ENDPOINT = `${API_BASE_URL}/user/getUserPrivileges`;
export const ADDAPPITEMS_ENDPOINT = `${API_BASE_URL}/app/add-appitem`;
export const GETCOLORTAG_ENDPOINT = `${API_BASE_URL}/app/get-colortags`;
export const ADDCATEGORY_ENDPOINT = `${API_BASE_URL}/app/add-category`;
export const UPDATECOLORTAG_ENDPOINT = `${API_BASE_URL}/app/update-colortags`;
export const GETDEPT_ENDPOINT = `${API_BASE_URL}/user/getdept`;
export const ADDDEPT_ENDPOINT = `${API_BASE_URL}/user/add-dept`;
export const UPDATEDEPT_ENDPOINT = `${API_BASE_URL}/user/update-dept`;
export const DELETEDEPT_ENDPOINT = `${API_BASE_URL}/user/delete-dept`;
export const GETDEPTBYID_ENDPOINT = `${API_BASE_URL}/user/getdeptbyID`;
export const GETUSERROLE_ENDPOINT = `${API_BASE_URL}/user/getrole`;
export const CREATEUSER_ENDPOINT = `${API_BASE_URL}/user/createUser`;
export const CREATETMSUSER_ENDPOINT = `${API_BASE_URL}/user/TMS/createUser`;
export const GETUSERBYEMAIL_ENDPOINT = `${API_BASE_URL}/user/getuserbyemail`;
export const ADDUSERPRIVILLAGES_ENDPOINT = `${API_BASE_URL}/user/add-userprivileges`;
export const UPDATEAPPITEM_ENDPOINT = `${API_BASE_URL}/app/update-appitem`;
export const GETCATEGORYBYID_ENDPOINT = `${API_BASE_URL}/app/get-category`;
export const UPDATECATEGORY_ENDPOINT = `${API_BASE_URL}/app/update-category`;
export const RESETPASSWORD_ENDPOINT = `${API_BASE_URL}/user/resetpassword`;
export const DELETEUSER_ENDPOINT = `${API_BASE_URL}/user/deleteuserbyemail`;
export const DELETEUSERPRIVILLAGE_ENDPOINT = `${API_BASE_URL}/user/deletePrivilage`;
export const UPDATEUSERINFO_ENDPOINT = `${API_BASE_URL}/user/updateUser`;
export const VALIDATEUSER_ENDPOINT = `${API_BASE_URL}/user/validate`;
export const GETUSERS_ENDPOINT = `${API_BASE_URL}/user/getusers`;
export const GETUSERSBYID_ENDPOINT = `${API_BASE_URL}/user/getuserbyID`;
export const DELETECATEGORY_ENDPOINT = `${API_BASE_URL}/app/delete-category`;
export const DELETEAPPITEM_ENDPOINT = `${API_BASE_URL}/app/delete-appitem`;
export const ADDACTIVITYLOG_ENDPOINT = `${API_BASE_URL}/app/addactivitylog`;
export const GETACTIVITYLOG_ENDPOINT = `${API_BASE_URL}/app/getactivitylog`;
export const GETAUDITLOGWITHRANGE_ENDPOINT = `${API_BASE_URL}/app/getauditlogwithrange`;
export const RESETUSERPASSWORD_ENDPOINT = `${API_BASE_URL}/user/resetuserpassword`;
export const GETLOGSLIST_ENDPOINT = `${API_BASE_URL}/app/list-files`;
export const DOWNLOADLOG_ENDPOINT = `${API_BASE_URL}/app/download-file`;
export const TELNETCHECK_ENDPOINT = `${API_BASE_URL}/app/telnet-check`;
export const RESTARTSERVICE_ENDPOINT = `${API_BASE_URL}/app/restart-service`;

//End

//Modules Configurations ( Add all new modules config parameters here)

// 1:  Netpay Module

export const NETPAYAPI_BASE_URL =
  "https://paywithbank3d.com/SAP.NetpayAPI/api/netpay";

export const RESTARTSETTLEMENT_ENDPOINT = `${NETPAYAPI_BASE_URL}/restart`;
export const CHECKSETTELEMTSTATUS_ENDPOINT = `${NETPAYAPI_BASE_URL}/check-settlement`;
export const GETSETTELEMTSTATUS_ENDPOINT = `${NETPAYAPI_BASE_URL}/getstatus`;
export const GETNETPAYTRANSACTION_ENDPOINT = `${NETPAYAPI_BASE_URL}/getTransactions`;
export const UPDATESETTLEMENT_ENDPOINT = `${NETPAYAPI_BASE_URL}/update-settlement`;
export const ADDREPROCESSEDRECORD_ENDPOINT = `${NETPAYAPI_BASE_URL}/addreprocessrecords`;
export const GETREPROCESSEDRECORD_ENDPOINT = `${NETPAYAPI_BASE_URL}/getreprocessedrecords`;

// Swwipe Backend URL

// export const SWWIPE_BASE_URL = "https://app.swwipe.com/Swwipe.API/api/v1";
export const SWWIPE_BASE_URL = "https://app.swwipe.com/api/v1";

// 2:  Sale Executive Module

export const SAVEANDCONTINUE_ENDPOINT = `${API_BASE_URL}/app/save-onboarding-data`;
export const UPDATEDONOTSHOW_ENDPOINT = `${API_BASE_URL}/app/DoNotShow`;
export const UPDATECONTINUEONBOARD_ENDPOINT = `${API_BASE_URL}/app/update-onboarding-data`;
export const GETPENDINGONBOARD_ENDPOINT = `${API_BASE_URL}/app/get-onboarding-data`;
export const DELETEDATA_ENDPOINT = `${API_BASE_URL}/app/delete-onboarding-data`;
export const GETALLSTATE_ENDPOINT = `${SWWIPE_BASE_URL}/Lookup/states`;
export const ACCOUNTINQUIRY_ENDPOINT = `${SWWIPE_BASE_URL}/Lookup/account`;
export const VALIDATEBVN_ENDPOINT = `${SWWIPE_BASE_URL}/Lookup/validate/bvn`;
export const VALIDATENIN_ENDPOINT = `${SWWIPE_BASE_URL}/Lookup`;
export const CREATEMERCHANT_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/create`;
export const GETMERCHANT_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal`;
export const GETBANKCODE_ENDPOINT = `${SWWIPE_BASE_URL}/Lookup/bankCode`;
export const ADDCASHIER_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/cashiers`;
export const GETLOCATIONSDETAILS_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/locations`;
export const DASHBOARDATA_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/dashboard`;
export const MERCHARNTDATA_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/merchants`;
export const SUPERADMINDASHBOARDATA_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/super-admin/report`;
export const SALEEXEUTIVEDATA_ENDPOINT = `${SWWIPE_BASE_URL}/AdministrativePortal/super-admin/businesses`;
export const INAPPNOTIFICATION_ENDPOINT = `${SWWIPE_BASE_URL}/Notification/sendinappnotificationtoall`;
export const GETBUSINESSTYPES_ENDPOINT = `${SWWIPE_BASE_URL}/Public/businessType`;

// TMS Backend URL

export const TMS_BASE_URL = "https://staging.swwipe.com/Swwipe.TMS/api/v1";

// 2:  TMS Module

export const GETBANKMERCHANT_ENDPOINT = `${TMS_BASE_URL}/Terminal/merchants`;
export const GETBANKMERCHANT_ENDPOINT_AUTHTOKEN = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1laWQiOiIxIiwiZW1haWwiOiJ0bXNhZG1pbkBzd3dpcGUuY29tIiwianRpIjoiMmMxYWM1MmEtMDQ2Ny00Njc4LTgxODYtYzMzYTBmM2Y0MTA1Iiwicm9sZSI6IkFkbWluIiwibmJmIjoxNzI0NjU3NzU4LCJleHAiOjE4ODUzNjE3NTgsImlhdCI6MTcyNDY1Nzc1OCwiaXNzIjoiaHR0cHM6Ly93d3cuc2VjdXJpdHkuY29tIiwiYXVkIjoiaHR0cHM6Ly93d3cuc2VjdXJpdHkuY29tIn0.a-wU__H4t7DEKjoqz5WnXrLzHc4yX4h7cKkIBWsAg4s`;
